import { Api } from '@beautybox/core/api';
import { joinQueryObj } from '@beautybox/core/utils';

/** Инициализация модуля запросов */
let provider;
export function init(config) {
    provider = new Api(config.BASE_URL, 'link', config.token, false);
}

/** Начальное состояние */
const initialState = () => ({
    categories: [],
    emptySearch: false,
    loadingDataServices: false,
    loadingServices: true,
    modelSearchServicesOnline: '',
    query: '',
    services: {},
});

/** Мутации услуг */
const mutations = {
    ADD_SERVICES(state, services) {
        console.log('--- ADD_SERVICE');
        state.services = { ...services };
    },
    ADD_CATEGORIES(state, categories) {
        console.log('--- ADD_CATEGORIES', categories);
        state.categories = categories;
    },
    ADD_TO_QUERY(state, query = {}) {
        state.query = joinQueryObj(query, state.query);
        console.log('--- ADD_TO_QUERY', state.query);
    },
    SET_MODEL_SEARCH_SERVICES_ONLINE(state, payload) {
        state.modelSearchServicesOnline = payload;
    },
    TOGGLE_EMPTY_SEARCH(state, payload) {
        state.emptySearch = payload;
    },
    CLEAR_QUERY(state) {
        state.query = '';
        console.log('--- CLEAR_QUERY', state.query);
    },
};

/** Экшены услуг */
const actions = {
    /** Получение всего массива услуг */
    async GET_SERVICES({ rootState, state, commit }, { id }) {
        console.log('---GET_SERVICES');
        state.loadingServices = true;
        if (id) {
            const { errors = {}, ...response } = await provider.get(`/${id}/services-online`);

            if (!Object.keys(errors).length) {
                await commit('ADD_SERVICES', response);
            }
        }
        state.loadingServices = false;
    },
    /** Получение категорий для модуля Box */
    async GET_CATEGORIES_BOX({ commit }, { id }) {
        console.log('--- GET_CATEGORIES_BOX');

        const { errors = {}, categories } = await provider.get(`/${id}/categories`);

        if (!Object.keys(errors).length) {
            await commit('ADD_CATEGORIES', categories);
        }
    },
    /** Получение категорий для модуля Online */
    async GET_CATEGORIES_ONLINE({ rootGetters, state, commit }, { id, employeeID }) {
        commit('CLEAR_QUERY');

        state.loadingDataServices = true;

        const bid = rootGetters.BIDS[rootGetters.BID_INDEX];
        const date = bid.date;
        const time = bid.time;
        const employee = bid.employee;
        const servicesIDs = bid.servicesIDs;

        if (date.length) {
            commit('ADD_TO_QUERY', { date });
        }
        if (time.length) {
            commit('ADD_TO_QUERY', { time });
        }
        if (servicesIDs.length) {
            commit('ADD_TO_QUERY', { serviceIDs: servicesIDs.join(',') });
        }
        if (Object.keys(employee).length || employeeID) {
            const id = employeeID ? employeeID : employee.employeeID;
            commit('ADD_TO_QUERY', { employeeID: id });
        }

        console.log('--- GET_CATEGORIES_ONLINE_REQUEST', `/${id}/categories-online${state.query}`);

        const { errors = {}, categories = [] } = await provider.get(
            `/${id}/categories-online${state.query}`
        );

        if (!Object.keys(errors).length) {
            await commit('ADD_CATEGORIES', categories);
            state.loadingDataServices = false;
        }
    },
};

/** Геттеры услуг */
const getters = {
    CATEGORIES: (state) => state.categories.sort((a, b) => a.sort - b.sort),
    SERVICES:
        (state) =>
        (array, filter = '') => {
            const services = array
                .map((item) => state.services[item])
                .sort((a, b) => {
                    return a.sort - b.sort;
                })
                .filter((item) => typeof item === 'object');

            if (Boolean(filter)) {
                const regex = /[\._\-\/\*\(\)/\s]/g;
                let val = '';

                if (Boolean(state[filter])) {
                    val = state[filter].toUpperCase().replace(regex, '');
                }

                return services.filter((el) => {
                    const serviceName = el.name.toUpperCase().replace(regex, '');
                    return serviceName.includes(val);
                });
            } else {
                return services;
            }
        },
    MODEL_SEARCH_SERVICES_ONLINE: (state) => state.modelSearchServicesOnline,
    EMPTY_SEARCH: (state) => state.emptySearch,
    LOADING_SERVICES: (state) => state.loadingServices,
    LOADING_DATA_SERVICES: (state) => state.loadingDataServices,
    HAS_SERVICES: (state) => !!Object.keys(state.services).length,
};

export default { init, state: initialState, mutations, actions, getters };
